/**
 * On scroll we tag the scrolled element with `is-scrolling`; the stylesheet
 * reveals the thumb for `.is-scrolling`. A per-element timer removes the class
 * once scrolling stops.
 */
const SCROLLING_CLASS = 'is-scrolling';
const HIDE_DELAY_MS = 2000;

const hideTimers = new WeakMap<Element, ReturnType<typeof setTimeout>>();

const handleScroll = (event: Event): void => {
  const { target } = event;
  // The document/page scroll reports `document` as the target; the element that
  // actually owns the scrollbar is the root <html>.
  const element = target instanceof Document ? target.documentElement : (target as Element | null);

  if (!(element instanceof Element)) return;

  element.classList.add(SCROLLING_CLASS);

  const existing = hideTimers.get(element);
  if (existing) clearTimeout(existing);

  hideTimers.set(
    element,
    setTimeout(() => {
      element.classList.remove(SCROLLING_CLASS);
      hideTimers.delete(element);
    }, HIDE_DELAY_MS),
  );
};

let initialized = false;

export const initScrollbarVisibility = (): void => {
  if (initialized || typeof document === 'undefined') return;
  initialized = true;
  document.addEventListener('scroll', handleScroll, true);
};
